export const VISI_WRITER_HISTORY_FLAG = "visi-writer-history";

export const CHAT_SEARCH_PARAM = "chat";

export const CHAT_UNAVAILABLE_MESSAGE = "This chat is no longer available.";
